import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { OdontoWrapperDto } from 'src/app/model/odonto/wrapper.dto';

@Component({
  selector: 'ms-odonto-wrapper',
  templateUrl: './odonto.wrapper.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoWrapperComponent,
      multi: true,
    },
  ],
})
export class OdontoWrapperComponent extends BaseValueAccessor<OdontoWrapperDto> {
  @Input() turn = -1;
  @Input() patient = -1;
  @Input() isFirst = true;
}
